export const LOCAL_STORAGE_KEY = {
  OPEN_WINDOW: 'openWindow',
  KEY_LANGUAGE: 'language',
  RECENT_SEARCH_INDEX: 'recentSearchIndex',
  KEY_TIMEZONE: 'timeZone',
  DEVICE_KEY: 'fiinGate.deviceKey.',
  AUTH_TIME: 'fiinGate.authTime.',
  KEY_FONT_SIZE: 'fontSize',
  RETURN_URL: 'returnUrl',
  SIGNIN_COUNT: 'signinCount',
  SIGNIN_CALLBACK_COUNT: 'signinCallbackCount',
  KICKED_DEVICE: 'kickedDevice',
}
